import { render, staticRenderFns } from "./TripLegCollapsible.vue?vue&type=template&id=b12f6276&"
import script from "./TripLegCollapsible.vue?vue&type=script&lang=js&"
export * from "./TripLegCollapsible.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports